export default "__VITE_ASSET__vZfNEv1w__"